// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReviewSlider_wrapper__c6lPG","title":"ReviewSlider_title__X2EMq","slider":"ReviewSlider_slider__Fu2ZB"};